import type { SoilRecipe } from '../../types/careExpanded';

interface SoilRecipesSectionProps {
  recipes: SoilRecipe[];
}

export function SoilRecipesSection({ recipes }: SoilRecipesSectionProps) {
  if (recipes.length === 0) {
    return (
      <p className="text-sm text-gray-500 italic">No soil recipes available</p>
    );
  }

  return (
    <div className="space-y-4">
      {recipes.map((recipe, index) => (
        <div
          key={index}
          className="p-4 rounded-lg bg-background border border-gray-200"
        >
          {/* Recipe name */}
          <h4 className="font-medium text-editorial-black mb-2">{recipe.name}</h4>

          {/* Ingredients list */}
          <ul className="space-y-1.5 mb-3">
            {recipe.ingredients.map((ingredient, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-editorial-black">
                <span className="text-primary mt-0.5" aria-hidden="true">•</span>
                <span>{ingredient}</span>
              </li>
            ))}
          </ul>

          {/* Use case */}
          {recipe.useCase && (
            <p className="text-xs text-gray-500 italic mt-2 pt-2 border-t border-gray-100">
              {recipe.useCase}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
